<template>
  <div class="about">
    <nav>
      <TopNav />
    </nav>
    <div class="page1">
      <img class="mask-bg" src="../../assets/image/about1.jpg"/>
    </div>
  </div>
</template>
<script>
import TopNav from "./components/TopNav.vue";

export default {
  name: "About",
  components: {TopNav}
}
</script>
<style lang="less"  scoped>
.about {
  height: 100%;
  font-size: 16px;
  .page1 {
    height: 100%;
    overflow: hidden;
    img {
      min-height: 100%;
      display: block;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/new/About.vue